<div class="assignment-gap-choice">
    <mat-form-field>
        @if (!selectedValue) {
        <span class="mat-form-placeholder" i18n>Klik hier</span>
        }

        <mat-select
            [(ngModel)]="selectedValue"
            [class]="{
                'mat-select--correct': answerState === answerStateEnum.Correct,
                'mat-select--incorrect':
                    answerState === answerStateEnum.InCorrect
            }"
            (ngModelChange)="clearState()"
        >
            @for (option of options; track option) {
            <mat-option
                [value]="option.value"
                [id]="option.entryId"
                [class]="
                    option.isCorrect()
                        ? 'mat-option--correct'
                        : 'mat-option--incorrect'
                "
            >
                {{ option.value }}
            </mat-option>
            }
        </mat-select>
    </mat-form-field>

    <app-state-icon [state]="answerState"></app-state-icon>
</div>
